import styled from '@emotion/styled';

export const ReviewBarWrapper = styled.div`
  width: 100%;
  max-width: 1360px;
  min-height: 90px;
  background: transparent;
  margin-top: 30px;
  margin: 30px auto 0;

  @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
    display: flex;
    min-height: 175px;
    align-items: center;
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .footer-logos {
    width: 100%;
    display: flex;
    align-items: center;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      justify-content: space-between;
    }

    .tuv-logo {
      width: 140px;
    }

    .trustpilot-widget iframe {
      max-width: 125px;
      margin-right: 20px;
    }
  }
`;
